/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { Map } from "@iventis/mapbox-gl";
import { TileLayer } from "@deck.gl/geo-layers";
import { BitmapLayer } from "@deck.gl/layers";
import { MapBackgroundDataStore, MapBackground as MapBackgroundType } from "../../../../data-store/basemap/map-background-data-store";
import { DeckglMapboxIntegration } from "../../deckgl/deckgl-mapbox-integration";
import { Basemap } from "../basemap";

export class DeckglMapBackground extends Basemap<MapBackgroundType, never> {
    public readonly id: string;

    private readonly deckglMapboxIntegration: DeckglMapboxIntegration;

    private readonly onFinishedLoadingBackground: () => void;

    constructor(id: string, mapBackgroundDataStore: MapBackgroundDataStore, map: Map, deckglMapboxIntegration: DeckglMapboxIntegration, onFinishedLoadingBackground: () => void) {
        super(id, mapBackgroundDataStore, map);
        this.deckglMapboxIntegration = deckglMapboxIntegration;
        this.onFinishedLoadingBackground = onFinishedLoadingBackground;
        this.addToMap();
    }

    protected async addToMap() {
        // Get the map background from our CDN
        const mapBackground = await this.basemapDataStore.getBasemap(this.id);
        const rasterSource = Object.values(mapBackground.sources).find((source) => source.type === "raster");
        // Get url of the tiles
        const url = rasterSource.tiles[0];

        const mapBackgroundLayer = new TileLayer({
            id: this.id,
            data: url,
            maxZoom: rasterSource.maxzoom ?? 22,
            minZoom: rasterSource.minzoom ?? 0,
            metadata: {
                mapBackgroundName: mapBackground.metaData?.name,
            },
            renderSubLayers: (props) => {
                const { boundingBox } = props.tile;
                const { data, ...otherProps } = props;
                return new BitmapLayer({
                    ...otherProps,
                    image: data,
                    bounds: [boundingBox[0][0], boundingBox[0][1], boundingBox[1][0], boundingBox[1][1]],
                });
            },
            // Once the tiles have loaded in the map
            onViewportLoad: () => {
                const finishedLoading = !this.loaded;
                this.loaded = true;
                if (finishedLoading) {
                    this.onFinishedLoadingBackground();
                }
            },
            pickable: true,
        });

        this.deckglMapboxIntegration.addLayerToExternalOverlay(mapBackgroundLayer);
    }

    public updateFillExtriusionVisibility(_: boolean) {
        // Do nothing, there are no 3d buildings to show on raster imagery
    }

    public updateSymbolsVisibility(_: boolean) {
        // Do nothing, there is not text with the Deckgl raster imagery
    }

    public remove() {
        this.deckglMapboxIntegration.removeLayer(this.id);
    }
}
